import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      appName: 'AegisNet AI',
      tagline: 'Autonomous, Predictive & Self-Healing Emergency Intelligence',
      login: 'Login',
      logout: 'Logout',
      citizen: 'Citizen',
      responder: 'Responder',
      admin: 'Admin / Commander',
      sos: 'SOS',
      emergency: 'Emergency',
      fire: 'Fire',
      medical: 'Medical',
      flood: 'Flood',
      other: 'Other',
      alertSent: 'Alert Sent',
      respondersNotified: 'Responders notified in',
      seconds: 'seconds',
      safeZones: 'Nearby Safe Zones',
      navigate: 'Navigate',
      myAlerts: 'My Alerts',
      markSafe: 'Mark Safe',
      aiAssistant: 'AI Assistant',
      send: 'Send',
      activeIncidents: 'Active Incidents',
      acceptMission: 'Accept Mission',
      missionBrief: 'AI Mission Brief',
      teamCoordination: 'Team Coordination',
      commandCenter: 'Command Center',
      analytics: 'Live Analytics',
      prediction: 'AI Prediction Engine',
      simulation: 'Digital Twin Simulation',
      runSimulation: 'Run Simulation',
      totalToday: 'Total Today',
      avgResponseTime: 'Avg Response Time',
      livesProtected: 'Lives Protected',
      falseAlarmRate: 'False Alarm Rate',
      incidentHeatmap: 'Incident Heatmap',
      verificationScore: 'Verification Score',
      offlineMode: 'Offline Mode Active — Mesh Network Enabled',
      degradedMode: 'Degraded Network — Local Cache Active',
      connectedMode: 'Cloud Connected — Full AI Active',
      firePrompt: 'What to do in a fire?',
      medicalPrompt: 'I am having a medical emergency',
      floodPrompt: 'Flood near me',
      email: 'Email',
      password: 'Password',
      signingIn: 'Signing in...',
      searchIncidents: 'Search incidents...',
      resolved: 'Resolved',
      pending: 'Pending',
      active: 'Active',
      falseAlarm: 'False Alarm',
    },
  },
  hi: {
    translation: {
      appName: 'एजिसनेट AI',
      tagline: 'स्वायत्त, भविष्यसूचक और आपातकालीन बुद्धिमत्ता',
      login: 'लॉगिन',
      logout: 'लॉगआउट',
      citizen: 'नागरिक',
      responder: 'रेस्पॉन्डर',
      admin: 'एडमिन / कमांडर',
      sos: 'एसओएस',
      emergency: 'आपातकाल',
      fire: 'आग',
      medical: 'चिकित्सा',
      flood: 'बाढ़',
      other: 'अन्य',
      alertSent: 'अलर्ट भेजा गया',
      respondersNotified: 'रेस्पॉन्डर को सूचित किया गया',
      seconds: 'सेकंड में',
      safeZones: 'पास के सुरक्षित क्षेत्र',
      navigate: 'नेविगेट',
      myAlerts: 'मेरे अलर्ट',
      markSafe: 'सुरक्षित चिह्नित करें',
      aiAssistant: 'AI सहायक',
      send: 'भेजें',
      activeIncidents: 'सक्रिय घटनाएं',
      acceptMission: 'मिशन स्वीकार करें',
      missionBrief: 'AI मिशन ब्रीफ',
      teamCoordination: 'टीम समन्वय',
      commandCenter: 'कमांड सेंटर',
      analytics: 'लाइव एनालिटिक्स',
      prediction: 'AI भविष्यवाणी इंजन',
      simulation: 'डिजिटल ट्विन सिमुलेशन',
      runSimulation: 'सिमुलेशन चलाएं',
      totalToday: 'आज का कुल',
      avgResponseTime: 'औसत प्रतिक्रिया समय',
      livesProtected: 'संरक्षित जीवन',
      falseAlarmRate: 'गलत अलार्म दर',
      incidentHeatmap: 'घटना हीटमैप',
      verificationScore: 'सत्यापन स्कोर',
      offlineMode: 'ऑफलाइन मोड सक्रिय — मेश नेटवर्क सक्षम',
      degradedMode: 'नेटवर्क खराब — लोकल कैश सक्रिय',
      connectedMode: 'क्लाउड कनेक्टेड — पूर्ण AI सक्रिय',
      firePrompt: 'आग लगने पर क्या करें?',
      medicalPrompt: 'मुझे चिकित्सा आपातकाल है',
      floodPrompt: 'मेरे पास बाढ़ है',
      email: 'ईमेल',
      password: 'पासवर्ड',
      signingIn: 'साइन इन हो रहा है...',
      searchIncidents: 'घटनाएं खोजें...',
      resolved: 'हल किया',
      pending: 'लंबित',
      active: 'सक्रिय',
      falseAlarm: 'गलत अलार्म',
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
